import { render, staticRenderFns } from "./AttivaOfferta.vue?vue&type=template&id=dd33eae4&scoped=true"
import script from "./AttivaOfferta.vue?vue&type=script&lang=js"
export * from "./AttivaOfferta.vue?vue&type=script&lang=js"
import style0 from "./AttivaOfferta.vue?vue&type=style&index=0&id=dd33eae4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd33eae4",
  null
  
)

export default component.exports